import * as questionIds from "../../consultationQuestions/questionIds";

export const gripStrengthQuestions = [
    {
        id: questionIds.GripStrengthUnableToCarryOut,
        questionText: "Unable to carry out medical",
    },
    {
        id: questionIds.GripStrengthUnableToCarryOutReason,
        questionText: "Reason medical not carried out",
    },
    {
        id: questionIds.GripStrengthLeftHandMeasurement1,
        questionText: "Measurement 1 (kg)",
    },
    {
        id: questionIds.GripStrengthLeftHandMeasurement2,
        questionText: "Measurement 2 (kg)",
    },
    {
        id: questionIds.GripStrengthLeftHandMeasurement3,
        questionText: "Measurement 3 (kg)",
    },
    {
        id: questionIds.GripStrengthLeftHandAverageMeasurement,
        questionText: "Average Measurement (kg)",
    },
    {
        id: questionIds.GripStrengthRightHandMeasurement1,
        questionText: "Measurement 1 (kg)",
    },
    {
        id: questionIds.GripStrengthRightHandMeasurement2,
        questionText: "Measurement 2 (kg)",
    },
    {
        id: questionIds.GripStrengthRightHandMeasurement3,
        questionText: "Measurement 3 (kg)",
    },
    {
        id: questionIds.GripStrengthRightHandAverageMeasurement,
        questionText: "Average Measurement (kg)",
    }
];
